import React from "react";

const OnHoldJobs = () => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="54" height="54" rx="8" fill="#E1D9FF" />
      <path
        d="M27 27C25.7625 27 24.7031 26.5594 23.8219 25.6781C22.9406 24.7969 22.5 23.7375 22.5 22.5C22.5 21.2625 22.9406 20.2031 23.8219 19.3219C24.7031 18.4406 25.7625 18 27 18C28.2375 18 29.2969 18.4406 30.1781 19.3219C31.0594 20.2031 31.5 21.2625 31.5 22.5C31.5 23.7375 31.0594 24.7969 30.1781 25.6781C29.2969 26.5594 28.2375 27 27 27ZM18 36V32.85C18 32.2125 18.1641 31.6266 18.4922 31.0922C18.8203 30.5578 19.2563 30.15 19.8 29.8688C20.9625 29.2875 22.1437 28.8516 23.3438 28.5609C24.5438 28.2703 25.7625 28.125 27 28.125C28.2375 28.125 29.4563 28.2703 30.6562 28.5609C31.8562 28.8516 33.0375 29.2875 34.2 29.8688C34.7438 30.15 35.1797 30.5578 35.5078 31.0922C35.8359 31.6266 36 32.2125 36 32.85V36H18Z"
        fill="#7C6ABB"
      />
    </svg>
  );
};

export default OnHoldJobs;
